// extracted by mini-css-extract-plugin
export default {"cls1":"sehCuOlF2fszQ3dFfvF9","cls2":"okaXx9nE1xFCBej_Z_gY sehCuOlF2fszQ3dFfvF9"};